import React from 'react';
import styles from './Forms.module.scss';

export default function Row(props) {
  return (
    <div className={styles['form-row']}>
      {props.children}
    </div>
  )
}